import { useEffect, useState } from 'react';

import Geo, { countries, generateIdValueMap } from './index';

export default function useGeo(countryId, regionId, countryList = countries) {
  const [data, setData] = useState({
    countries: countryList,
    regions: [],
    matchedCountry: null,
    matchedRegion: null
  });

  useEffect(() => {
    setData(state => {
      const countryIdMap = generateIdValueMap(state.countries);
      return { ...state, matchedCountry: countryIdMap[countryId] || null };
    });
    Geo.getRegions(countryId).then(function(regions) {
      setData(state => ({ ...state, regions }));
    });
  }, [countryId]);

  useEffect(() => {
    Geo.getRegion(countryId, regionId).then(function(matchedRegion) {
      setData(state => ({ ...state, matchedRegion }));
    });
  }, [countryId, regionId]);

  return data;
}
